import { controlsContainerStyles } from "@insite/content-library/Widgets/ProductList/ProductListControlsContainer";
import { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import { SPACING } from "@store/theme/design";
import breakpointValuesMediaQueries from "@store/utilities/breakpointValuesMediaQueries";
import { css } from "styled-components";

Object.assign(controlsContainerStyles, {
    ...controlsContainerStyles,
    container: {
        gap: 0,
        css: css`
            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [
                        {
                            values: [
                                `${SPACING.standard} 0`,
                                null,
                                null,
                                `${SPACING.standard} ${SPACING.xsmall}`,
                                null,
                            ],
                            properties: ["padding"],
                        },
                    ],
                    mediaOptions.min,
                )}
        `,
    },
    countGridItem: {
        width: [2, 2, 2, 6, 6],
    },
    sortGridItem: {
        width: [10, 10, 10, 6, 6],
        css: css`
            text-align: right;
        `,
    },
    viewSelectGridItem: {
        width: [0, 0, 0, 0, 0],
        css: css`
            display: none;
        `,
    },
});
